<script>
import BlockingContainer from '@components/BlockingContainer';
import DownloadCategoryModel from '@models/DownloadCategory';

export default {
  components: {
    BlockingContainer,
  },
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      category: {
        name: null,
        show_remark: false,
        show_google_link: false,
      },
    };
  },
  mounted() {
    if (this.loadedId) {
      this.$wait.start('category processing');
      DownloadCategoryModel.find(this.loadedId)
        .then((response) => {
          this.category = Object.assign({}, this.category, response);
          this.$wait.end('category processing');
        })
        .catch(() => this.$wait.end('category processing'));
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('category processing');
          this.submit();
        }
      });
    },
    submit() {
      new DownloadCategoryModel(this.category)
        .save()
        .then(() => {
          this.$wait.end('category processing');
          this.$emit('submitted');
        })
        .catch(() => this.$wait.end('category processing'));
    },
  },
};
</script>

<template>
  <div class="position-relative">
    <BlockingContainer v-if="$wait.is('category processing')" />
    <b-form @submit.prevent="validate">
      <b-form-group :label="$t('fields.name')" label-for="category-name">
        <b-form-input
          id="category-name"
          v-model="category.name"
          v-validate="'required'"
          data-vv-name="name"
          :placeholder="$t('placeholders.name')"
          :state="errors.has('name') ? false : null"
        />
        <b-form-invalid-feedback>{{ errors.first('name') }}</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox id="category-show-remark" v-model="category.show_remark" :value="1" :unchecked-value="0">
          {{ $t('fields.show_remark') }}
        </b-form-checkbox>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox id="category-show-google-link" v-model="category.show_google_link" :value="1" :unchecked-value="0">
          {{ $t('fields.show_google_link') }}
        </b-form-checkbox>
      </b-form-group>

      <b-btn type="submit" variant="outline-dark" :disabled="$wait.is('category processing')">
        {{ $t('actions.submit') }}
      </b-btn>
    </b-form>
  </div>
</template>
